import {
  isLauncherJourney,
  type Journey as JourneyV3
} from '@epilot/journey-logic-commons'
import { up } from '@epilot/journey-logic-commons/src/schemas/v4'
import type { Journey } from '@epilot/journey-logic-commons/src/types/next'

import type { JourneyChangedAction } from '../types/actions'
import { APP_ERROR } from '../types/enums'

import { actionFactory } from './factory'
import { setAppError } from './setAppError'

/**
 * Responsible for processing a Journey config after fetching from the API or receiving it via
 * event in case of a preview session.
 */
export const journeyChanged = actionFactory<JourneyChangedAction>(
  (state, { journey }) => {
    const castedJourney = journey as JourneyV3
    const id = journey.journeyId

    if (!id) {
      return void setAppError(
        {
          error: APP_ERROR.JOURNEY_NOT_FOUND,
          reason: 'Journey Id is missing.'
        },
        state
      )
    }

    state.journeys[id] = {
      originalJourney: castedJourney,
      journey: trySchemaUp(castedJourney)
    }

    // caches the launcher-type check for further use
    if (state.journeys[id].journey === undefined) {
      state.journeys[id].isLauncherType = isLauncherJourney(castedJourney.steps)
    }
  },
  'journeyChanged'
)

/**
 * Safely attempts to transform the Journey schema from v3 to v4.
 * If the transformation fails, it returns undefined and logs the error.
 */
export const trySchemaUp = (journey: JourneyV3): Journey | undefined => {
  try {
    return up(journey)
  } catch (originalError) {
    const error = new Error(`Error transforming Journey schema`)

    error.cause = originalError

    // eslint-disable-next-line no-console
    console.error(error, { journeyId: journey.journeyId })

    return undefined
  }
}
